import { Injectable } from '@angular/core';
import { LocalStorageService } from '@df/browser/storage/local-storage.service';
import { IdleExpiry } from './expiry';

/**
 * Represents a localStorage store of expiry values.
 * @extends IdleExpiry
 */
@Injectable({
    providedIn: 'root'
})
export class IdleExpiryLocalStorageService extends IdleExpiry {
    private idleName = 'main';

    constructor(protected localStorage: LocalStorageService) {
        super();
    }

    /**
     * Gets or sets the last expiry date in localStorage.
     * If localStorage doesn't work correctly (i.e. Safari in private mode), we store the expiry value in memory.
     * @param value - The expiry value to set; omit to only return the value.
     * @return The current expiry value.
     */
    last(value?: Date): Date | null {
        if (value !== void 0) {
            this.setExpiry(value);
        }

        return this.getExpiry();
    }

    override idling(value?: boolean): boolean | null {
        if (value !== void 0) {
            this.setIdling(value);
        }

        return this.getIdling();
    }

    /**
     * Gets the idle name.
     * @return The name of the idle.
     */
    getIdleName(): string {
        return this.idleName;
    }

    /**
     * Sets the idle name.
     * @param key The name of the idle.
     */
    setIdleName(key: string): void {
        if (key) {
            this.idleName = key;
        }
    }

    private getExpiry(): Date | null {
        const expiry: string = this.localStorage.get(this.idleName + '.expiry');

        if (expiry) {
            return new Date(parseInt(expiry, 10));
        } else {
            return null;
        }
    }

    private setExpiry(value: Date) {
        if (value) {
            this.localStorage.set(this.idleName + '.expiry', value.getTime().toString());
        } else {
            this.localStorage.remove(this.idleName + '.expiry');
        }
    }

    private getIdling(): boolean {
        const idling: string = this.localStorage.get(this.idleName + '.idling');

        if (idling) {
            return idling === 'true';
        } else {
            return false;
        }
    }

    private setIdling(value: boolean) {
        if (value) {
            this.localStorage.set(this.idleName + '.idling', value.toString());
        } else {
            this.localStorage.set(this.idleName + '.idling', 'false');
        }
    }
}
